import {MainVideoState} from "../definitions/MainVideoState";

export const toggleGrid = (state: MainVideoState) => {
    state.shouldShowGrid = !state.shouldShowGrid;
};
